import { nomenclators } from '@mep/pae-commons';
import { Empty, Form, Select, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { i18n } from '@/settings';

const { BANK_TYPES_INFO_ENUM } = nomenclators;

const { Option } = Select;

const BankTypeSelect = ({ value, onChange, province, valueKey, fullObject, ...props }) => {
  const { t } = useTranslation('common');
  
  const onClearHandler = useCallback(() => {
    onChange && onChange(null);
  }, [onChange]);
  
  const onChangeValueHandler = useCallback((e, f) => {
    if (!fullObject)
      onChange && onChange(e);
    else
      onChange && onChange({ [valueKey]: f?.[valueKey], name: f?.type });
  }, [fullObject, onChange, valueKey]);
  
  return (
    <Select
      showSearch={false}
      allowClear={false}
      {...props}
      notFoundContent={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
      value={value?.[valueKey] || value}
      onChange={onChangeValueHandler}
      onClear={onClearHandler}
    >
      {BANK_TYPES_INFO_ENUM
        .filter(e => province ? !!e?.isVisible && !!e?.isVisible(province) : true)
      // eslint-disable-next-line no-unused-vars
        .map(({ isVisible, label, ...rest }, index) => {
          const exist = i18n.exists(`bankTypes.${rest?.type}`);
          return <Option {...rest} key={index} value={rest[valueKey]} title={label}>
            <Tooltip title={exist ? t(`bankTypes.${rest?.type}`) : label}>
              {exist ? t(`bankTypes.${rest?.type}`) : label}
            </Tooltip>
          </Option>;
        })}
    </Select>
  );
};

BankTypeSelect.propTypes = {
  province: PropTypes.string,
  valueKey: PropTypes.string,
  fullObject: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func
};

BankTypeSelect.defaultProps = {
  valueKey: 'code'
};

export default memo(BankTypeSelect);

export const renderBankTypeSelect = ({ formItemProps, field, form }) => {
  const { address } = form.getFieldsValue();
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <BankTypeSelect {...field?.widgetProps} {...field} province={address?.province || null} form={form}/>
    </Form.Item>
  );
};
